var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { CircularProgress, styled, useTheme, useMediaQuery, } from '@mui/material';
import { useAudioPlayerContext } from 'hx-audio-player';
import { usePreviewLoop } from 'hx-din-test-2';
import { Slider } from 'hx-ui';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { BsVolumeOff, BsVolumeUp } from 'react-icons/bs';
export function VolumeSelectContent() {
    var theme = useTheme();
    var _a = useFormContext(), getValues = _a.getValues, setValue = _a.setValue;
    var selectedVolume = getValues('volume');
    var setVolume = useAudioPlayerContext().setVolume;
    var state = usePreviewLoop().dinPlayer.state;
    useEffect(function () {
        if (!selectedVolume) {
            setVolume(0.1);
            return;
        }
        setVolume(selectedVolume / 100);
    }, [selectedVolume]);
    var incrementVolume = function () { return setValue('volume', +selectedVolume + 10); };
    var decrementVolume = function () { return setValue('volume', +selectedVolume - 10); };
    var isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
    if (state.status === 'initializing') {
        return (_jsx("div", __assign({ className: "grid w-full h-full place-items-center" }, { children: _jsx(CircularProgress, {}) })));
    }
    function formatLabel(value) {
        return "".concat(value / 10);
    }
    return (_jsxs("div", __assign({ className: "flex flex-col md:gap-6 gap-2 justify-between h-full w-full items-center md:px-12 px-6" }, { children: [_jsx(Slider, { orientation: 'horizontal', sx: {
                    border: 'none',
                    width: '100%',
                    height: '7px',
                    '& .MuiSlider-root': {
                        scale: 5,
                    },
                    '& .MuiSlider-track': {
                        border: 'none',
                        height: 7,
                    },
                    '& .MuiSlider-thumb': {
                        background: theme.palette.primary.main,
                    },
                }, step: 10, name: "volume", className: "flex flex-row w-full gap-4 mt-28", classes: {
                    valueLabel: 'text-orange text-2xl bg-transparent top-0 -right-2 font-medium',
                    rail: 'h-0.5 bg-slate-800 opacity-100',
                    track: 'bg-orange',
                }, valueLabelFormat: formatLabel, valueLabelDisplay: isMobile ? 'on' : 'off', BeforeIcon: _jsx(VolumeControl, __assign({ onClick: decrementVolume }, { children: _jsx(BsVolumeOff, { size: "2rem", color: theme.palette.primary.main }) })), AfterIcon: _jsx(VolumeControl, __assign({ onClick: incrementVolume }, { children: _jsx(BsVolumeUp, { size: "2rem", color: theme.palette.primary.main }) })) }), _jsx(Typography, __assign({ variant: "h5", className: "font-semibold text-xl" }, { children: "Faites glisser le curseur pour ajuster le volume" })), _jsxs(Typography, __assign({ variant: "caption" }, { children: ["Le niveau d'\u00E9coute confortable varie d'une personne \u00E0 l'autre.", _jsx("br", {}), "Veuillez trouver votre propre niveau d'\u00E9coute confortable. Vous devriez \u00EAtre capable d'entendre clairement les chiffres prononc\u00E9s. Si vous AJUSTEZ les niveaux de volume \u00AB trop fort \u00BB ou \u00AB trop faible \u00BB, vous risquez de compromettre la pr\u00E9cision des r\u00E9sultats de votre test auditif."] }))] })));
}
var VolumeControl = styled('div')({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
});
